import { Component, OnInit } from '@angular/core';
import { Taxpayer } from '../taxpayer';
import { TaxpayerRegistrationService } from '../services/taxpayer-registration.service';
import { Observable, pipe } from 'rxjs';
import { tap } from 'rxjs/operators';


@Component({
  selector: 'app-request-form',
  templateUrl: './request-form.component.html',
  styleUrls: ['./request-form.component.scss']
})
export class RequestFormComponent implements OnInit {

  taxpayerModel : ITaxpayer;
  tcctypeHasError = true;
  disableTin : boolean = false;
  isSuccessful : boolean;
  tinIsValid : boolean;
  validPeriod = [
    {days: "30 days", desc: "Provisional"},
    {days: "90 days", desc: "Conditional"},
    {days: "180 days", desc: "Regular"},
    {days: "360 days", desc: "Annual"}
  ];
  public selectedValue : any = null;
  public tpEnterprise$: Observable<boolean>;
  public taxpayerEnterprises:Array<any>;
  //public enterpriseList: Array<string>;
  private _isIndividual: boolean;

  constructor(private trs : TaxpayerRegistrationService) { }

  public get isIndividual(): boolean {
    return this._isIndividual;
  }
  public set isIndividual(value: boolean) {
    this._isIndividual = value;
  }

  ngOnInit() {
    
    this.taxpayerModel = {
      taxpayer_no : 0,
      taxpayer_type : "",
      taxpayer_subtype: "",
      tccType : "",
      tin : "",
      tpname : "",
      email : "",
      phone : "",
      contactPerson : "",
      address : "",
      division_name : "",
      division_no : 0,
      tax_center_no: 0,
      business_sector: ""
    };
   //this.enterpriseList=[];
  }

  validateTcctype(value){
    if(value==="default"){
      this.tcctypeHasError=true;
    }
    else{
      this.tcctypeHasError=false;
    }

  }
  onSubmit(){
    this.isSuccessful = false;
    this.trs.register(this.taxpayerModel).subscribe(
      data => {
        this.isSuccessful = true;
        this.taxpayerModel.taxpayer_no = 0;
        this.taxpayerModel.address = "";
        this.taxpayerModel.contactPerson="";
        this.taxpayerModel.email="";
        this.taxpayerModel.phone="";
        this.taxpayerModel.tin="";
        this.taxpayerModel.tpname="";
        this.taxpayerModel.division_name="";
        this.taxpayerModel.taxpayer_type="";
        this.taxpayerModel.taxpayer_subtype="";
        this.taxpayerModel.business_sector="";
        this.taxpayerModel.tccType ="";
        this.taxpayerModel.division_no=0;
        this.taxpayerModel.tax_center_no=0;
        this.taxpayerModel.taxpayer_no=0;
      },
      error => console.error("Error", error)
    );
  }

  onBlur(){     
    this.trs.getEnterprises(this.taxpayerModel.tin).subscribe(data=>this.taxpayerEnterprises=data);
         

    this.trs.getDetails(this.taxpayerModel.tin).subscribe(
      data =>{
        if(data!==null){
          this.tinIsValid = true
        }
      
        let  entName: string = data.ENT_REGNAME;
        this.taxpayerModel.address = data.COUNTY+", "+data.STREET_NAME+", "+data.AREA_VILLAGE //+", "+data.DOOR_NO;
        this.taxpayerModel.contactPerson=data.CONTACT_PERSON;
        if(!this.empty(data.ADDRESS_E_MAIL)){
          this.taxpayerModel.email=data.ADDRESS_E_MAIL.toLowerCase();
        }
        console.log(this.taxpayerModel.email);
        this.taxpayerModel.phone=data.MOBILE_PHONE
        this.taxpayerModel.tin=data.FISCAL_NO;
        if(this.taxpayerEnterprises.length>=1){
          this.taxpayerEnterprises.forEach(element=>{
            if(this.empty(element.REGIST_NAME)){
              this.taxpayerModel.tpname =element.FULLNAME;
              this.isIndividual=true;
            }
            else{ 
              this.taxpayerModel.tpname =element.REGIST_NAME;
              console.log(element.REGIST_NAME);
            }  
          });
        }
        else{
          this.taxpayerModel.tpname =data.ENT_REGNAME;;
        }
        
       // this.taxpayerModel.tpname=data.TAXPAYER_NAME;
        this.taxpayerModel.division_name=data.TAX_DIVISION_NAME;
        this.taxpayerModel.taxpayer_type=data.TAX_PAYER_TYPE;
        this.taxpayerModel.taxpayer_subtype=data.TAXPAYER_SUBTYPE;
        this.taxpayerModel.business_sector=data.BUSINESS_SECTOR;
        this.taxpayerModel.division_no=data.TAX_DIVISION_NO;
        this.taxpayerModel.tax_center_no=data.TAX_CENTRE_NO;
        this.taxpayerModel.taxpayer_no=data.TAX_PAYER_NO;
        
      });
  }

  onChange(){
    this.tinIsValid = false;
  }

  empty(str:string):boolean{
    if (typeof str == 'undefined' || !str || str.length === 0 || str === "" || !/[^\s]/.test(str) || /^\s*$/.test(str) || str.replace(/\s/g,"") === "")
    {
        return true;
    }
    else
    {
        return false;
    }
  }
}
